export default "__VITE_ASSET__BZArIe75__"